module.exports = __webpack_public_path__ + "img/japan1.8fadfbcc.jpg";